import Typography from "@mui/material/Typography";

import { evaluateScopes, ScopesEvaluationSummary } from "utility/google";
import { GenericObject } from "utility/misc";

// -----------------------------------------------------------------------------

export default function GoogleConnectedExtraDetails(secret: GenericObject) {
  const details: StateDetails = processStateDetails(secret.stateDetails);
  const permissionsStatusMessage: React.ReactNode = getPermissionMessage(
    details.scopes
  );

  //
  return (
    <Typography variant="body1">
      Permissions: {permissionsStatusMessage}
    </Typography>
  );
}

// -----------------------------------------------------------------------------

function processStateDetails(stateDetails: string): StateDetails {
  try {
    return JSON.parse(stateDetails) as StateDetails;
  } catch (error: any) {
    return {
      scopes: [],
      customer: { id: "-1", domain: "" },
      error: error.message,
    };
  }
}

function getPermissionMessage(scopes: string[]): React.ReactNode {
  const permissionsEval = evaluateScopes(scopes);

  switch (permissionsEval.summary) {
    case ScopesEvaluationSummary.Insufficient:
      return "Insufficient permissions";

    case ScopesEvaluationSummary.ReadOnly:
      return "Read-only";

    case ScopesEvaluationSummary.ReadWrite:
      return "Read-write";

    case ScopesEvaluationSummary.ReadOnlyPartial:
      return "Read-only (partial)";

    case ScopesEvaluationSummary.ReadWritePartial:
      return "Read-write (partial)";
  }
}

// -----------------------------------------------------------------------------

interface StateDetails {
  scopes: string[];
  customer: {
    id: string;
    domain: string;
  };

  error?: string;
}
